module.exports = __webpack_public_path__ + "img/our-space-logo-white-medium.6cc79d9b.svg";